<span #svgContainer [inlineSVG]="src" [setSVGAttributes]="svgAttributes" [style.--svg-fill]="svgAttributes.fill"></span>
